var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.getLayout,{tag:"component",attrs:{"sidebar":_vm.sidebar,"environment":_vm.environment,"environmentUser":_vm.environmentUser,"viewId":_vm.viewId,"viewParams":_vm.viewParams,"noPadding":_vm.noPadding,"path":_vm.path}})
}
var staticRenderFns = []

export { render, staticRenderFns }